export default "__VITE_ASSET__a51fb06e__"